export interface CaseEvent {
  date: string;
  time: string;
  place: string;
  venue: string;
  type: CaseEventType;
}

export enum CaseEventType {
  FUNERAL = 'FUNERAL',
  BIRTH = 'BIRTH',
  DEATH = 'DEATH',
}
